<template>
  <div id="widget-attributes">
    <h2 class="subtitle is-3">{{ $t("widget_details.custom_attributes") }}</h2>
    <div class="columns">
      <div class="column is-12">
        <div v-if="$i18n.locale == 'fr'">
          <b-table
            striped
            :bordered="isBordered"
            :mobile-cards="hasMobileCards"
            :data="widget.customAttributesFr"
            :columns="columnsFr"
          >
          </b-table>
        </div>
        <div v-else>
          <b-table
            striped
            :bordered="isBordered"
            :mobile-cards="hasMobileCards"
            :data="widget.customAttributes"
            :columns="columns"
          >
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WidgetAttributesTable",
  props: {
    widget: { type: Object, required: true }
  },
  data: function() {
    return {
      isBordered: false,
      hasMobileCards: true,
      columns: [
        {
          field: "name",
          label: "Attribute",
          width: "220",
          class: "row-code"
        },
        {
          field: "default",
          label: "Default",
          width: "220",
          class: "row-code"
        },
        {
          field: "description",
          label: "Description",
          renderHtml: true
        }
      ],
      columnsFr: [
        {
          field: "name",
          label: "Attribut",
          width: "220",
          class: "row-code"
        },
        {
          field: "default",
          label: "Défaut",
          width: "220",
          class: "row-code"
        },
        {
          field: "description",
          label: "Description",
          renderHtml: true
        }
      ]
    };
  }
};
</script>

<style>
.b-table .table th {
  background: #f0f9ff;
  color: #274f6e;
  font-weight: 600;
}
.row-code {
  color: #274f6e;
  font-family: monospace;
  font-size: 15px;
}
.b-table .table td {
  padding: 16px;
}
.table.is-striped tbody tr:not(.is-selected):nth-child(2n) {
  background-color: #f9fcfd;
}
</style>
